import { useState } from "react";
import { ShoppingCart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetTrigger } from "@/components/ui/sheet";
import { Badge } from "@/components/ui/badge";
import { useCart } from "@/contexts/CartContext";
import { CartDrawer } from "@/components/CartDrawer";

export function Cart() {
  const { totalItems } = useCart();
  const [open, setOpen] = useState(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          aria-label={`Open cart (${totalItems} items)`}
          className="relative gap-2 rounded-full px-4 border-primary/40 bg-primary/10 text-foreground hover:bg-primary hover:text-primary-foreground transition-colors"
        >
          <ShoppingCart className="h-4 w-4" />
          <span className="font-semibold text-sm">Cart</span>
          {totalItems > 0 && (
            <Badge className="ml-1 h-5 min-w-5 px-1.5 flex items-center justify-center bg-destructive text-destructive-foreground text-xs font-bold">
              {totalItems}
            </Badge>
          )}
        </Button>
      </SheetTrigger>
      <CartDrawer close={() => setOpen(false)} />
    </Sheet>
  );
}
